function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.143.03v17.273L16 24.633V19.65l-8.6-4.903v-7.7L16 11.95v-4.6zm0 0",
  fill: "#002a41"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#0071b5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.857.03v17.273L16 24.633V19.65l8.6-4.903v-7.7L16 11.95v-4.6zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.143 31.97V14.696L16 7.367v4.982l-8.6 4.903v7.3L16 19.66v4.982zm0 0"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.857 31.97V14.696L16 7.367v4.982l8.6 4.903v7.3L16 19.66v4.982zm0 0",
  fill: "#002a41"
});

function SvgBackbonejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    fillRule: "evenodd",
    stroke: "#848484",
    strokeWidth: 0.036,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbonejs);
export default __webpack_public_path__ + "static/media/backbonejs.b57aa1e0.svg";
export { ForwardRef as ReactComponent };